<template>
  <v-row>
    <v-col cols="12">
      <v-card class="px-2">
        <v-card-title>
          360 Settings
        </v-card-title>
        <v-divider></v-divider>
        <v-form ref="form" v-model="valid">
          <v-card-text class="subtitle-1">
            <v-row>
              <v-col cols="12" class="font-weight-bold pb-0 secondary--text">
                360 Review Status
              </v-col>
              <v-col cols="12" class="pt-0">
                Allow our system to collect valuable feedback from employees in
                your organization
              </v-col>
              <v-col cols="auto">
                <v-select
                  outlined
                  v-model="settings.isReviewPaused"
                  :items="statusItems"
                  item-text="name"
                  item-value="id"
                  class="min-width"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="font-weight-bold pb-0 secondary--text">
                Review Frequency
              </v-col>
              <v-col cols="12" class="pt-0">
                How often would you like to run your 360 review program?
              </v-col>
              <v-col cols="auto">
                <v-select
                  outlined
                  v-model="settings.reviewFrequencyId"
                  :items="review_frequencies"
                  item-text="name"
                  item-value="id"
                  :rules="[$rules.required]"
                  required
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="font-weight-bold pb-0 secondary--text">
                Review Collection
              </v-col>
              <v-col cols="12" class="pt-0">
                How many review questions would you like each member to answer?
              </v-col>
              <v-col cols="auto">
                <v-text-field
                  v-model="settings.numberOfQuestionsPerPeriod"
                  outlined
                  :rules="[$rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="font-weight-bold pb-0 secondary--text">
                Review Questions
              </v-col>
              <v-col cols="12" class="pt-0">
                What should we ask your employees?
              </v-col>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondarytext"
                  to="/features/reviews/settings/questions"
                >
                  Manage Questions
                </v-btn>
                <span class="success--text ml-2">
                  {{ overview.questionCount }} active questions
                </span>
              </v-col>
              <v-col cols="12">
                <info-card icon="wifi_tethering" title="Your Review Summary">
                  Every month, each employee will be asked
                  {{ settings.numberOfQuestionsPerPeriod }} questions at
                  different times during the month. Our system will work to get
                  you the best feedback coverage for each employee in your
                  organization.
                </info-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="save" :loading="saving">Save</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ReviewSettings",
  data: () => ({
    saving: false,
    valid: false,
    statusItems: [
      { id: false, name: "Active" },
      { id: true, name: "Inactive" }
    ]
  }),
  computed: {
    ...mapGetters({
      settings: "profile/settings",
      review_frequencies: "lookup/review_frequencies",
      active_questions: "settings/active_review_questions",
      overview: "review/overview"
    })
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch("settings/saveReviewSettings", this.settings)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Review Settings saved");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occurred while saving your review settings."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
